export default __webpack_public_path__ + "static/media/info-signs.cca73e16.svg";